import { OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { UsersService } from '../phone-numbers/users/users.service';
import { Ng1AccountService } from '../shared/ng1/ng1-account.service';
import { environment } from '../../environments/environment';
var AccountsComponent = /** @class */ (function () {
    function AccountsComponent(usersService, ng1AccountService) {
        this.usersService = usersService;
        this.ng1AccountService = ng1AccountService;
        this.accounts = [];
    }
    AccountsComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.form = new FormGroup({
            search: new FormControl('')
        });
        this.usersService.getAccounts().subscribe(function (accounts) {
            _this.ng1AccountService.setAccountsLength(accounts.length);
            if (accounts.length === 1) {
                _this.choose(_this.accounts[0]);
            }
            _this.accounts = accounts;
        });
    };
    Object.defineProperty(AccountsComponent.prototype, "getFilteredAccounts", {
        get: function () {
            var _this = this;
            return this.accounts.filter(function (account) { return account.name.toLowerCase().includes(_this.form.get('search').value.toLowerCase()); });
        },
        enumerable: true,
        configurable: true
    });
    AccountsComponent.prototype.choose = function (account) {
        if (account.clientType.startsWith('SHOPER')) {
            var token = localStorage.getItem('ngStorage-authToken').replace(/\"/g, '');
            window.location.href = environment.SHOPER_CONNECT_URL + "/login#access_token=" + token + "&account=" + account.domain;
        }
        else {
            this.ng1AccountService.choose(account);
        }
    };
    return AccountsComponent;
}());
export { AccountsComponent };
